export interface InstallerJobQuestionnaire {
    id?: string;
    job_id?: string;
    question: string;
    answer?: string | null;
    is_required: boolean;
    answer_type: string; // e.g., "text", "select", etc.
    order: number;
    section: string; // e.g., "before_installation", "after_installation"
    created_datetime: string; // ISO date string
    created_by?: string | null; // e.g., "System" or user ID
    updated_datetime: string; // ISO date string
    updated_by?: string | null; // e.g., "System" or user ID
    answer_options?: string[]; // Optional, for select type questions
}

export const InstallerQuestions: InstallerJobQuestionnaire[] = [
    {
        question:
            "If the toilet was removed, was it placed inside the tub with a protective layer (carpet piece, sheet vinyl etc.) on the bottom?",
        is_required: true,
        answer_type: "radio",
        order: 0,
        section: "before_installation",
        created_datetime: new Date().toISOString(),
        updated_datetime: new Date().toISOString(),
        answer_options: ["Yes", "No", "N/A"],
    },
    {
        question: "Was the job site completely cleaned and vacuumed?",
        is_required: true,
        answer_type: "radio",
        order: 0,
        section: "after_installation",
        created_datetime: new Date().toISOString(),
        updated_datetime: new Date().toISOString(),
        answer_options: ["Yes", "No", "N/A"],
    },
    {
        question: "Has the trash been taken out of the unit?",
        is_required: true,
        answer_type: "radio",
        order: 1,
        section: "after_installation",
        created_datetime: new Date().toISOString(),
        updated_datetime: new Date().toISOString(),
        answer_options: ["Yes", "No", "N/A"],
    },
    {
        question: "Was the unit locked, and keys returned to the management?",
        is_required: true,
        answer_type: "radio",
        order: 2,
        section: "after_installation",
        created_datetime: new Date().toISOString(),
        updated_datetime: new Date().toISOString(),
        answer_options: ["Yes", "No", "N/A"],
    },
    {
        question:
            "Were all appliances (Fridge, Washer, Dryer, Stove etc.) and Furniture (Doors etc.) put back in the same place?",
        is_required: true,
        answer_type: "radio",
        order: 3,
        section: "after_installation",
        created_datetime: new Date().toISOString(),
        updated_datetime: new Date().toISOString(),
        answer_options: ["Yes", "No", "N/A"],
    },
    {
        question: "Status of the work?",
        is_required: true,
        answer_type: "select",
        order: 3,
        section: "after_installation",
        created_datetime: new Date().toISOString(),
        updated_datetime: new Date().toISOString(),
        answer_options: ["Need more time", "Completed", "N/A"],
    },
];
